import CategoriaService from 'src/modules/categoria/categoriaService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'CATEGORIA_FORM';

const categoriaFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await CategoriaService.find(id);
      }

      dispatch({
        type: categoriaFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaFormActions.INIT_ERROR,
      });

      getHistory().push('/categoria');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaFormActions.CREATE_STARTED,
      });

      await CategoriaService.create(values);

      dispatch({
        type: categoriaFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.categoria.create.success'),
      );

      getHistory().push('/categoria');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: categoriaFormActions.UPDATE_STARTED,
      });

      await CategoriaService.update(id, values);

      dispatch({
        type: categoriaFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.categoria.update.success'),
      );

      getHistory().push('/categoria');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default categoriaFormActions;
